import clientRequest from '@/utils/clientRequest';

const PATH = '/user';

export const checkUserId = (userId: string) => clientRequest({
  url: `${PATH}/id-check/${userId}`,
  method: 'get',
});

export const checkRegisterNo = (params: any) => clientRequest({
  url: `${PATH}/register-check`,
  method: 'get',
  params,
});

export const joinBusinessUser = (data: any) => clientRequest({
  url: `${PATH}/join/business`,
  method: 'post',
  data,
});
